import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
// ** Config
import themeConfig from '@configs/themeConfig'
import Proptypes from 'prop-types'

class AppBranding extends Component {

  constructor(props) {
    super(props)
    this.state = {
      appName: props.appName,
      type: props.type,
      src: props.src,
      icon: props.icon,
      logo: props.logo,
      expanded: props.expanded,
      classNames: props.classNames,
      style: props.style,
      alt: props.alt
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (_.includes(this.state.type, ['ICON_LABEL'])) {
      if (this.props.expanded !== this.state.expanded) {
        this.setState({
          expanded: this.props.expanded
        })
      }
    }
  }

  iconLabelRender = () => {
    const {appName, src, icon, classNames, style, alt} = this.state
    return (
      <Fragment>
        <span className='brand-logo'>
          <img src={icon || src || require('@csrc/assets/images/logo/logo.png').default} className={classNames.img || ''} style={style} alt={alt || appName}/>
        </span>
        <h2 className='brand-text mb-0'>{appName || themeConfig.app.appName}</h2>
      </Fragment>
    )
  }

  logoRender = () => {
    const {appName, src, logo, classNames, style, alt} = this.state
    return (
      <Fragment>
        <img src={logo || src || require('@csrc/assets/images/logo/logo-full.png').default} className={classNames.img || ''} style={style} alt={alt || appName}/>
      </Fragment>
    )
  }

  iconRender = () => {
    const {appName, src, icon, classNames, style, alt} = this.state
    return (
      <Fragment>
        <img src={icon || src || require('@csrc/assets/images/logo/logo.png').default} className={classNames.img || ''} style={style} alt={alt || appName}/>
      </Fragment>
    )
  }

  render() {
    const {iconLabelRender, logoRender, iconRender} = this
    const {type} = this.state
    return (
      <Fragment>
        {type === 'ICON_LABEL' && iconLabelRender()}
        {type === 'LOGO' && logoRender()}
        {type === 'ICON' && iconRender()}
      </Fragment>
    )
  }
}

AppBranding.defaultProps = {
  type: 'ICON_LABEL',
  src: '',
  expanded: false,
  classNames: {},
  style: {},
  alt: ''
}
AppBranding.propTypes = {
  type: Proptypes.oneOf(['ICON_LABEL', 'LOGO', 'ICON']),
  src: Proptypes.any,
  expanded: Proptypes.bool,
  classNames: Proptypes.shape({
    img: Proptypes.string
  }),
  style: Proptypes.object,
  alt: Proptypes.string
}

const mapStateToProps = store => ({
  appName: store.app?.settings?.app?.display_name,
  icon: store.app?.settings?.app?.logo,
  logo: store.app?.settings?.app?.logo_full
})
export default connect(mapStateToProps)(AppBranding)
